import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class ActiveAd extends PureComponent {
    constructor() {
        super();
        this.onLinkClick = this.onLinkClick.bind(this);
    }

    onLinkClick() {
        this.props.onLinkClick(this.props.adid, this.props.heading);
    }

    render() {
        return (
            <div className="grid__unit">
                <div className="panel">
                    <h3>
                        <a href={this.props.link} onClick={this.onLinkClick}>
                            {this.props.jobtitle}
                        </a>
                    </h3>
                    <p>{this.props.heading}</p>
                    <p>
                        {this.props.companyname}, {this.props.location}
                    </p>
                </div>
            </div>
        );
    }
}

ActiveAd.propTypes = {
    onLinkClick: PropTypes.func.isRequired,
    companyname: PropTypes.string.isRequired,
    adid: PropTypes.string.isRequired,
    jobtitle: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    location: PropTypes.string,
    link: PropTypes.string.isRequired,
};
